import React, { useRef, Suspense } from 'react';
import { Canvas, useLoader, useFrame } from '@react-three/fiber';
import { TextureLoader } from 'three/src/loaders/TextureLoader';

/**
 * Sphere
 */

const Sphere = (props) => {
  const mesh = useRef();
  const [worldMap] = useLoader(TextureLoader, [`${process.env.PUBLIC_URL}/images/map-world.png`]);

  useFrame(() => (mesh.current.rotation.y += 0.0025));

  return (
    <mesh {...props} ref={mesh}>
      <sphereGeometry args={[1, 64, 64]} />
      <meshPhongMaterial map={worldMap} />
    </mesh>
  );
};

/**
 * Earth
 */

const Earth = () => (
  <Canvas pixelRatio={window.devicePixelRatio} camera={{ position: [0, 0.25, 1.75] }} className="earth">
    <Suspense fallback={null}>
      <ambientLight position={[-12, 12, 6]} color="#aaa" intensity={0.8} />
      <directionalLight position={[-12, 12, 4]} color="#fff" intensity={0.8} />
      <Sphere position={[0, 0, 0]} rotation={[0.5, 0, 0]} />
    </Suspense>
  </Canvas>
);

export default Earth;
